<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useMessageContext } from './provider.js';
import { MESSAGE_VARIANTS } from './constants';

// Mirrors CaptainGenerationDetails visually, but Meta returns no run detail for
// its agent's replies, so this is a plain attribution badge rather than a
// popover with a timeline.
const { t } = useI18n();
const { variant } = useMessageContext();

// Same as Captain: badge pinned to the start of the row, meta pushed to the end,
// regardless of which side the bubble sits on.
const badgeColorClass = computed(() =>
  variant.value === MESSAGE_VARIANTS.PRIVATE
    ? 'text-n-amber-12/40'
    : 'text-n-slate-11/60'
);
</script>

<template>
  <div class="flex items-center gap-1.5 justify-between">
    <span
      v-tooltip="t('CONVERSATION.META_AGENT_GENERATION.TITLE')"
      class="inline-flex items-center gap-1"
      :class="badgeColorClass"
    >
      <Icon icon="i-ph-sparkle-fill" class="size-3.5" />
      <span class="text-xs">
        {{ t('CONVERSATION.META_AGENT_GENERATION.GENERATED_BY') }}
      </span>
    </span>
    <slot name="meta" />
  </div>
</template>
